const localstorage = {
  set: (key: string, value: unknown) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: <T = any>(key: string): T | undefined => {
    const json = localStorage.getItem(key);

    if (!json) return;

    try {
      const payload = JSON.parse(json);
      return payload as T;
    } catch (e) {
      return;
    }
  },

  remove: (key: string) => {
    localStorage.removeItem(key);
  },
};

export default localstorage;
